<template>
    <td class="TableCell" v-bind="$attrs">
        <slot />
    </td>
</template>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class TableCell extends Vue {
    }
</script>
